import React, { useEffect, useState } from 'react';
import { getdata, updatedata, getchiefofstaffstatus } from '../../util/global';

const ChiefSettings = () => {
  const [workspace,    setWorkspace]    = useState<any>({ businessname: 'Lumio' });
  const [saving,       setSaving]       = useState(false);
  const [saved,        setSaved]        = useState(false);
  const [zohoStatus,   setZohoStatus]   = useState<'connected' | 'demo' | 'loading'>('loading');

  const fetchConfig = async () => {
    try {
      const data = await getdata({ filter: { datatype: 'workspaceconfig' } });
      if (Array.isArray(data) && data.length > 0) setWorkspace(data[0]);
    } catch (err) {
      console.error(err);
    }
  };

  const saveWorkspace = async () => {
    setSaving(true);
    setSaved(false);
    try {
      await updatedata({ data: { ...workspace, datatype: 'workspaceconfig' } });
      setSaved(true);
      setTimeout(() => setSaved(false), 2500);
    } catch (err) {
      console.error(err);
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    fetchConfig();
    getchiefofstaffstatus().then((s: any) => setZohoStatus(s?.zoho === 'connected' ? 'connected' : 'demo'));
  }, []);

  return (
    <div className="chief-settings">
      <h2>Settings</h2>

      {/* ── Connectors ── */}
      <div className="chief-settings-section">
        <h3>Connectors</h3>

        <div className="chief-conn-card">
          <div className="chief-conn-icon">📒</div>
          <div className="chief-conn-info">
            <div className="conn-name">Zoho Books</div>
            <div className="conn-desc">Invoices, bills, expenses, receivables</div>
          </div>
          <span className={`chief-conn-badge ${zohoStatus === 'connected' ? 'connected' : 'demo'}`}>
            {zohoStatus === 'loading' ? '…' : zohoStatus === 'connected' ? 'Connected' : 'Demo'}
          </span>
        </div>

        <div className="chief-conn-card">
          <div className="chief-conn-icon">📊</div>
          <div className="chief-conn-info">
            <div className="conn-name">Meta Ads</div>
            <div className="conn-desc">Ad spend, ROAS, campaign performance</div>
          </div>
          <span className="chief-conn-badge demo">Demo</span>
        </div>

        <div className="chief-conn-card">
          <div className="chief-conn-icon">🛍️</div>
          <div className="chief-conn-info">
            <div className="conn-name">Shopify</div>
            <div className="conn-desc">Revenue, orders, products, customers</div>
          </div>
          <span className="chief-conn-badge demo">Demo</span>
        </div>

        <p style={{ fontSize: '0.8rem', color: 'var(--muted)', marginTop: '10px' }}>
          Zoho Books reads live via your existing integration. Meta Ads and Shopify coming in Phase 2–3.
        </p>
      </div>

      {/* ── Workspace ── */}
      <div className="chief-settings-section">
        <h3>Workspace</h3>
        <div className="chief-workspace-form">
          <div className="chief-fg">
            <label>Business Name</label>
            <input
              type="text"
              value={workspace.businessname || ''}
              onChange={e => setWorkspace((w: any) => ({ ...w, businessname: e.target.value }))}
              placeholder="e.g. Lumio"
            />
          </div>
          <button
            className="btn-gold"
            onClick={saveWorkspace}
            disabled={saving}
            style={{ marginTop: '4px' }}
          >
            {saving ? 'Saving…' : saved ? 'Saved ✓' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChiefSettings;
